module.exports = __webpack_public_path__ + "img/hygeia_logo.d3de564f.svg";